import { MARKETING_PROCESS, MarketingProcessCode } from '../../../constants';

export const isScalingEgProcess = (
  process: string | undefined,
): process is typeof MarketingProcessCode.SCALING_EG =>
  process === MarketingProcessCode.SCALING_EG;

export const isSimplifiedFlowProcess = (
  process: string | undefined,
): boolean =>
  process === 'inbox' || isScalingEgProcess(process);

export type CreativesParamFormat = 'pack' | 'flat' | 'empty';

/** Scaling EG stores a flat id list; every other process stores packs. */
export const expectedCreativesFormat = (
  process: string | undefined,
): Exclude<CreativesParamFormat, 'empty'> =>
  isScalingEgProcess(process) ? 'flat' : 'pack';

export const isCreativesFormatCompatible = (
  process: string | undefined,
  format: CreativesParamFormat,
): boolean => format === 'empty' || format === expectedCreativesFormat(process);

export const getCreativesFormatMismatchMessage = (
  process: string | undefined,
): string => {
  const processName =
    MARKETING_PROCESS.find(({ code }) => code === process)?.name ?? process ?? 'this marketing process';

  return `Creatives value is not relevant for ${processName}`;
};
